// extracted by css-extract-rspack-plugin
export default {"bodyMinHeight":"_9a403e0f"};